import { PageHeader, RegionCargando, Skeleton, Stack, TablaSkeleton } from "@/components/ui";
import { useAuthStore, useUserPermisos } from "@/lib/auth-store";
import { PERMISOS } from "@/lib/permisos";
import { encabezadoSolicitudes, esVistaSoloPropias } from "../utils/encabezado-solicitudes";
import { SolicitudesStats } from "./SolicitudesStats";
import { MIN_WIDTH_TABLA, columnasSolicitudes } from "./SolicitudesTable";

/**
 * «Mis solicitudes» en su primera carga · MISMA forma que `MisSolicitudesPage`
 * (contenedor, encabezado con su texto real, 4 cards de stats, toolbar y tabla
 * con sus columnas reales · tarjetas en móvil). Es el `pendingComponent` de la
 * ruta `/solicitudes` Y la rama `isPending` de la página: una sola fuente, así
 * la transición ruta → página no cambia de forma ni desplaza el layout.
 */
export function MisSolicitudesSkeleton() {
  const roles = useAuthStore((s) => s.user?.roles) ?? [];
  const { titulo, descripcion } = encabezadoSolicitudes(esVistaSoloPropias(roles));
  const puedeCrear = useUserPermisos().includes(PERMISOS.solicitudesGestionar);

  return (
    <RegionCargando etiqueta="Cargando solicitudes…" className="w-full px-4 py-6 md:px-6">
      <PageHeader
        title={titulo}
        description={descripcion}
        actions={
          // Switches «Mostrar facturas» y «Mostrar canceladas…» · exportar · refrescar ·
          // «Nueva solicitud» (si puede crear).
          <div className="flex items-center gap-2" aria-hidden="true">
            <Skeleton height={20} width={36} className="rounded-full" />
            <Skeleton height={14} width={110} className="mr-1" />
            <Skeleton height={20} width={36} className="rounded-full" />
            <Skeleton height={14} width={200} className="mr-1" />
            <Skeleton height={36} width={36} />
            <Skeleton height={36} width={36} />
            {puedeCrear && <Skeleton height={36} width={148} />}
          </div>
        }
      />
      <Stack gap="md">
        {/* El anuncio para lectores de pantalla ya lo hace el contenedor. */}
        <div aria-hidden="true">
          <SolicitudesStats total={0} enCaptura={0} requierenAccion={0} enAutorizacion={0} cargando />
        </div>
        <div aria-hidden="true">
          <TablaSkeleton columnas={columnasSolicitudes()} minWidth={MIN_WIDTH_TABLA} conToolbar movil />
        </div>
      </Stack>
    </RegionCargando>
  );
}
